import React from "react";
import Container from "react-bootstrap/Container";

const NotFound = () => {
  return (
    <div className="not-found-page">
      <Container>
        <div className="not-found-box">
          <img
            src="https://habib.edu.pk/wp-content/uploads/2023/12/404.png"
            alt="404"
            className="not-found-img top-img"
          />

          <img
            src="https://habib.edu.pk/wp-content/uploads/2023/12/404-habib.png"
            alt="Habib University"
            className="not-found-img bottom-img"
          />
        </div>
      </Container>
    </div>
  );
};

export default NotFound;